const footerLinks = {
  navigation: [
    { label: '精选推荐', href: '#carousel' },
    { label: '热门排行', href: '#ranking' },
    { label: '最新动态', href: '#updates' },
    { label: '常见问题', href: '#faq' },
  ],
  genres: [
    { label: '韩漫推荐', href: '#index' },
    { label: '日漫推荐', href: '#index' },
    { label: '国漫推荐', href: '#index' },
    { label: '全部漫画', href: '#index' },
  ],
  about: [
    { label: '关于我们', href: '#about' },
    { label: 'APP下载', href: '#app' },
    { label: '联系我们', href: '#contact' },
    { label: '读者评论', href: '#comments' },
  ],
};

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-10">
            <div className="col-span-2 md:col-span-1">
              <a
                href="#hero"
                onClick={(e) => handleNavClick(e, '#hero')}
                className="flex items-center gap-2 mb-4 cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-bold text-foreground-900 font-heading">
                  亲亲漫画
                </span>
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                亲亲漫画网——免费漫画在线阅读平台，提供海量韩漫、日漫、国漫全本下拉式阅读体验。每日更新，完全免费，免注册畅享所有内容。
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">漫画分类</h3>
              <ul className="space-y-2.5">
                {footerLinks.genres.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">关于本站</h3>
              <ul className="space-y-2.5">
                {footerLinks.about.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="border-t border-background-200/70 pt-8">
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h3>
              <p className="text-sm text-foreground-400">优质漫画平台与内容合作伙伴，共同为读者提供丰富阅读体验。</p>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-400">
                &copy; {new Date().getFullYear()} 亲亲漫画网. 本站内容仅供学习和交流，版权归原作者所有。
              </p>
              <p className="text-xs text-foreground-400">
                亲亲漫画官网首页入口 · 免费漫画在线阅读平台
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}